<template>
  <div class="row">
    <div class="col-md-6 my-5">
      <div class="titre-btn">Clients</div>
      <div class="row">
        <div class="col-5">
      <b-button id="show-btn" @click="showClientModal()" variant="outline-primary" class="add-button"
        >Nouveau client <font-awesome-icon :icon="['fas', 'plus']" /></b-button
      >
        </div>
      </div>

      <div class="wrapper-list">
        <vue-custom-scrollbar class="scroll-area" :settings="settings">
          <bloc-listing
          :datas="clientList"
          @deletedElement="getClientList"
          @modalEdition="handleModalEdition"
          >
          </bloc-listing>
        </vue-custom-scrollbar>
      </div>

      <!-- div class="more-link text-center" v-if="showAllLink">
        <b-link to="../mes-clients">Voir tous les clients</b-link>
      </div -->
    </div>
    <div class="col-md-6 left-padding my-5">
      <div class="titre-btn">Projets</div>
      <div class="row">
        <div class="col-5">
          <b-button
            id="show-btn"
            @click="showAddProjectModal"
            variant="outline-primary"
            class="add-button"
            >Nouveau projet <font-awesome-icon :icon="['fas', 'plus']" /></b-button
          >
        </div>

      </div>

      <div class="row">
        <div class="col-5">
          <div class="small-title-wrap">
            <div class="small-title">Recherche</div>
          </div>
          <FilterComponent @handleFilter="handleFilter"></FilterComponent>
        </div>
        <div class="col-7">
          <div class="small-title-wrap">
            <div class="small-title">Résultats</div>
          </div>
          <div class="wrapper-list">
            <vue-custom-scrollbar class="scroll-area custom-scroll-area-height" :settings="settings">
              <listing-projet :datas="projectList" @editProject="handleEditProject" @deleteProject="handleDeleteProject"></listing-projet>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>

      <!-- div class="more-link text-center">
        <b-link to="../../mes-projets">Voir tous les projets</b-link>
      </div -->
    </div>
    <div>
      <client-edit-modal
        :isEditMode="isEditMode"
        @updateClient="getClientList"
        ref="creationModalComponent"
      />
      <creation-modal
        class="base-modal"
        :title="newProjectModalTitle"
        id="addProject"
        ref="creationProject"
      >
        <creation-project-modal
          @stepNumber="changeTitleStep"
          @afterSubmitForm="handleAfterSubmitingForm"
          @cancel="hideModal('creationProject')"
        ></creation-project-modal>
      </creation-modal>

      <edit-stepped-modal
      ref="steppedModal"
      @updateEvent="getDetailProjectsList"
    ></edit-stepped-modal>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import CreationModal from '../utils/creationModal'
import clientEditModal from '../common/clientEditModal'
import editSteppedModal from '../editSteppedModal'
import BlocHeaderTitle from '../utils/blocHeaderTitle'
import BlocListing from '../utils/blocListing'
import ListingProjet from '../listProjet'
import creationProjectModal from '../creationProjectModal'
import FilterComponent from '../utils/filterComponent'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    listingProjet: ListingProjet,
    creationModal: CreationModal,
    blocHeaderTitle: BlocHeaderTitle,
    blocListing: BlocListing,
    creationProjectModal,
    vueCustomScrollbar,
    FilterComponent,
    editSteppedModal,
    clientEditModal
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      selected: 1,
      typeOptions: [
        { value: 1, text: 'Privé' },
        { value: 2, text: 'Collectivité' },
        { value: 3, text: 'SEM' },
        { value: 4, text: 'Etat' },
        { value: 5, text: 'EPS' },
        { value: 6, text: 'EPMS' },
        { value: 7, text: 'Particulier' },
        { value: 8, text: 'Autre' }
      ],
      form: {
        nom: '',
        contactNom: '',
        contactPrenom: '',
        contactTel1: '',
        contactTel2: '',
        email1: '',
        email2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: '',
        ville: '',
        pays: '',
        societe: this.userSocieteId(),
        typeClient: 1
      },
      clientList: [],
      showAllLink: false,
      isEditMode: false,
      clientId: 0,
      newProjectModalTitle: '',
      projectList: this.projectListing()
    }
  },
  mounted () {
    this.getClientList()
    this.projectListing()
  },
  methods: {
    ...mapActions(['setMessage', 'setPending', 'deleteProject', 'setProjectData', 'getProjectById', 'getFilterResults', 'addAdminClient', 'listAdminClient', 'getAdminClient', 'updateAdminClient', 'getProjectsByClient']),
    ...mapGetters(['userSocieteId', 'userId', 'pending']),
    handleEditProject (id) {
      this.getProjectById(id).then(resp => {
        this.setProjectData(resp)
        this.$refs['steppedModal'].openModal(id)
      })
    },
    handleDeleteProject (id) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer ce projet?`, {
        modalClass: 'base-modal',
        title: 'Suppression de projet',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            this.deleteProject(id).then(resp => {
              // this.$toaster.success('Projet supprimé')
              this.setMessage('Projet supprimé')
              this.projectList = this.projectList.filter((value, index, arr) => {
                return value.id !== id
              })
            })
          }
        })
    },
    handleChange (e) {
      this.form.typeClient = e
    },
    showClientModal (isEdit = false, id = null) {
      this.isEditMode = isEdit
      this.showModal('creationModalComponent', id)
    },
    handleModalEdition (id) {
      this.showClientModal(true, id)
    },
    showAddProjectModal () {
      this.showModal('creationProject')
    },
    showModal (ref, id = null) {
      this.$refs[ref].openModal(id)
    },
    hideModal (ref) {
      this.$refs[ref].closeModal()
    },
    handleRefreshList (datas) {
      this.clientList = datas
    },
    getClientList () {
      this.listAdminClient({ data: this.form.societe, page: 0 }).then((resp) => {
        // if (resp.items.length > 5) this.showAllLink = true
        this.clientList = resp.items.reverse() // .splice(0, 5)
      }, (err) => {
        console.log(err)
      })
    },
    changeTitleStep (step) {
      this.newProjectModalTitle = 'Nouveau projet ' + step + '/2'
    },
    projectListing () {
      this.getProjectsByClient({ socId: this.userSocieteId(), clientId: this.userId() }).then(resp => {
        this.projectList = resp.items
      })
    },
    handleAfterSubmitingForm (id) {
      this.$router.push('../mes-tableaux/' + id)
    },
    handleFilter (data) {
      // 'page=1&parPage=20&filtres[nom]=test&filtres[client]=&filtres[typeErp]=&filtres[ville]=yve'
      let urlParams = 'page=0&parPage=20'
      urlParams += data.nom ? '&filtres[nom]=' + data.nom : '&filtres[nom]='
      urlParams += data.client ? '&filtres[client]=' + data.client : '&filtres[client]='
      urlParams += data.typeErp ? '&filtres[typeErp]=' + data.typeErp : '&filtres[typeErp]='
      urlParams += data.ville ? '&filtres[ville]=' + data.ville : '&filtres[ville]='
      urlParams += data.numeroAffaire ? '&filtres[numeroAffaire]=' + data.numeroAffaire : '&filtres[numeroAffaire]='
      urlParams += data.statut ? '&filtres[etat]=' + (data.statut === 'En cours' ? 1 : 3) : '&filtres[etat]='

      this.getFilterResults({ id: this.userSocieteId(), data: urlParams }).then((resp) => {
        this.projectList = resp
      })
    },
    getDetailProjectsList () {
      this.getProjectsByClient({ socId: this.userSocieteId(), clientId: this.userId(), page: 0 }).then(resp => {
        this.projectList = resp.items
      })
    }

  }
}
</script>
<style lang="scss">
.left-padding {
  padding-left: 45px;
}
.wrapper-list {
  .scroll-area {
    height: 347px;
    margin-right: -15px;
    padding-right: 15px;
  }

  .custom-scroll-area-height {
    height:303px
  }

  .ps__thumb-x, .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    /*display: block;*/
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
.small-title-wrap{
  width: 100px;
  .small-title {
    color: #fff;
    background: rgba(147, 149, 193, 0.5);
    font-size: 15px;
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
    margin-bottom: 15px;
    border-radius: 3px;
    font-family: "Noto Sans", sans-serif;
    font-weight: normal;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dashboardComponent/index.vue